export const GET_INTEGRATION_CONTENT_TOOL = 'get_integration_content';
